import React from 'react';
import { NavLink } from 'react-router-dom';

const CategoriesCrumb = () => <NavLink to="/admin/categories">Categories</NavLink>;

export default CategoriesCrumb;
